<template>
    <div class="filter-content-entry" data-tab="category">
        <div class="filter-content-entry-mobile-title">
            <a href="#" class="btn btn-rebrand-grey-outline btn-rebrand-xxs px-2 back">{{translate.account.onboard.back}}</a>
            <span class="filter-title">{{translate.home.categories}}</span>
            <a href="#" class="btn btn-rebrand-black btn-rebrand-xxs ml-auto px-2"
               @click.prevent="clearAllFilters()">{{translate.home.clearAll}}</a>
        </div>
        <div class="row mb-5 filter-content-your-selection">
            <div class="col-md-12">
                <div class="section-heading mt-0 pt-0 border-0">{{translate.home.yourSelection}}</div>
                <div class="filter-content-your-selection-list">
                    <search-filter-flairs-scoped-component
                        :filterProp="'category'"
                    ></search-filter-flairs-scoped-component>
                    <a href="#" class="clear-filter-link" @click.prevent="clearAllFilters()">{{translate.home.clearAll}}</a>
                </div>
            </div>
        </div>
        <div class="row filter-content-container">
            <div class="col-md-8 col-lg-6">
                <div class="section-heading mt-0">{{translate.home.meetingLocation}}</div>
                <div class="radio-group-v2 full-width">
                    <input type="radio" name="meeting-location" id="input_meeting_location1"
                           @click="onFilterUpdated('meetingLocation', 0)"
                           :value="0" class="form-check-input"
                           :checked="categoryTemp.meetingLocation == 0"
                    >
                    <label for="input_meeting_location1">{{translate.home.inCall}}</label>

                    <input type="radio" name="meeting-location" id="input_meeting_location2"
                           @click="onFilterUpdated('meetingLocation', 1)"
                           :value="1" class="form-check-input"
                           :checked="categoryTemp.meetingLocation == 1"
                    >
                    <label for="input_meeting_location2">{{translate.home.outCall}}</label>

                    <input type="radio" name="meeting-location" id="input_meeting_location3"
                           @click="onFilterUpdated('meetingLocation', null)"
                           :value="2" class="form-check-input"
                           :checked="lodash.isNil(categoryTemp.meetingLocation)"
                    >
                    <label for="input_meeting_location3">{{translate.home.all}}</label>
                </div>

                <div class="section-heading">{{translate.home.type}}</div>
                <div class="radio-group-v2 full-width" v-if="shouldShowUserTypeCategoryProfessionalAmateur">
                    <input type="radio" name="type" id="type1" :value="0"
                           @click="onFilterUpdated('type', 0)"
                           :checked="categoryTemp.type == 0"
                           class="form-check-input">
                    <label for="type1">{{translate.home.professional}}</label>

                    <input type="radio" name="type" id="type2" :value="1"
                           @click="onFilterUpdated('type', 1)"
                           :checked="categoryTemp.type == 1"
                           class="form-check-input">
                    <label for="type2">{{translate.home.amateur}}</label>

                    <input type="radio" name="type" id="type3" :value="2"
                           @click="onFilterUpdated('type', null)"
                           :checked="lodash.isNil(categoryTemp.type)"
                           class="form-check-input">
                    <label for="type3">{{translate.home.all}}</label>
                </div>
                <div class="radio-group-v2 full-width" v-if="!shouldShowUserTypeCategoryProfessionalAmateur">
                    <input type="radio" name="isIndependentEscortCategory" id="isIndependent1" :value="1"
                           @click="onFilterUpdated('isIndependentEscortCategory', true)"
                           :checked="categoryTemp.isIndependentEscortCategory === true"
                           class="form-check-input">
                    <label for="isIndependent1">{{translate.account.independent}}</label>

                    <input type="radio" name="isIndependentEscortCategory" id="isIndependent2" :value="0"
                           @click="onFilterUpdated('isIndependentEscortCategory', false)"
                           :checked="categoryTemp.isIndependentEscortCategory === false"
                           class="form-check-input">
                    <label for="isIndependent2">{{translate.account.agency}}</label>

                    <input type="radio" name="isIndependentEscortCategory" id="isIndependent3" :value="null"
                           @click="onFilterUpdated('isIndependentEscortCategory', null)"
                           :checked="lodash.isNil(categoryTemp.isIndependentEscortCategory)"
                           class="form-check-input">
                    <label for="isIndependent3">{{translate.home.all}}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const data = () => {
        return {
            lodash: _,
            store: $store,
            unSubscribe: null,
        }
    };

    function mounted() {
        this.unSubscribe = this.store.subscribe((mutation) => {
            if (mutation.type === 'setFilterOpened'
                && mutation.payload
                && (!Object.keys(this.categoryTemp).length)
            ) {
                this.store.commit('setCategoryTemp', _.cloneDeep(this.category));
            }
        });
    }

    function onFilterUpdated(variable, value) {
        const tmp = _.cloneDeep(this.categoryTemp);
        tmp[variable] = value;

        this.store.commit('setCategoryTemp', tmp);
    }

    function clearAllFilters() {
        this.store.commit('setCategoryTemp', {});
    }

    export default {
        data,
        mounted,
        methods: {
            clearAllFilters,
            onFilterUpdated,
        },
        computed: {
            ...mapState([
                'category',
                'categoryTemp',
                'translate',
                'regionData'
            ]),
            shouldShowUserTypeCategoryProfessionalAmateur() {
                return !_.has(this.regionData, 'sectionsToHide.userTypeCategoryProfessionalAmateur');
            },
        },
        beforeDestroy() {
            if (this.unSubscribe) {
                this.unSubscribe();
            }
        },
    }
</script>
